import { render, staticRenderFns } from "./studentsfeesummary.vue?vue&type=template&id=cc3746d2&scoped=true&"
import script from "./studentsfeesummary.vue?vue&type=script&lang=js&"
export * from "./studentsfeesummary.vue?vue&type=script&lang=js&"
import style0 from "./studentsfeesummary.vue?vue&type=style&index=0&id=cc3746d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3746d2",
  null
  
)

export default component.exports